import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            海量资源 · 一站聚合
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            被窝网电影涵盖电影、电视剧、动漫、综艺等全品类影视资源，满足你的每一种观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 md:p-8 rounded-2xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-600`}></i>
              </div>
              <div className="text-center">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400">
                  {cat.count.toLocaleString()} 部资源
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}